import React, { useMemo } from 'react';
import { Col, DatePicker, Input, Radio, Select, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useOverviewLinkStateActions } from '../hooks/useOverviewLinkStateActions';
import { useOverviewLinkState } from '../linkstate/couponOverview.linkstate';
import { AccountStatusEnums, allCouponTypes, allCouponsStatus, allMicroCouponTypes } from '../../../shared/types';
import { isEmpty } from 'lodash';
import { useUserState } from '../../../Hooks/useUserState';
import { useGetOperatorQuery } from '../../../GraphQL/hooks/useGetOperatorQuery';
import moment from 'moment-timezone';

export const CouponFilter = () => {
    const isNotEmpty = (s: string) => s && !isEmpty(s);
    const [{ selectedDateRange, search, status, selectedTypes }] = useOverviewLinkState();
    const { patch: patchState } = useOverviewLinkStateActions();
    const { ...userState } = useUserState();
    const operatorId = userState?.operatorId;
    const { data: operator } = useGetOperatorQuery(operatorId);
    // Determine which coupon types to show
    const allowedCouponTypes = operator?.type === 'STASIA Mobility' ? allMicroCouponTypes : allCouponTypes;

    const rangePickerValue = useMemo(() => {
        return isNotEmpty(selectedDateRange?.fromDate) && isNotEmpty(selectedDateRange?.toDate)
            ? [moment(selectedDateRange?.fromDate), moment(selectedDateRange?.toDate)]
            : [null, null];
    }, [selectedDateRange]);

    const handleRangePickerChanged = (dates: [any, any]) => {
        patchState({
            selectedDateRange:
                dates && dates[0] && dates[1]
                    ? {
                          fromDate: dates[0].format('YYYY-MM-DD'),
                          toDate: dates[1].format('YYYY-MM-DD'),
                      }
                    : undefined,
        });
    };
    return (
        <>
            <Col md={{ span: 5 }}>
                <Input
                    value={search}
                    style={{ width: '100%' }}
                    placeholder={'Search by code'}
                    onChange={(e) => patchState({ search: e.target.value })}
                    addonBefore={<SearchOutlined />}
                />
            </Col>
            <Col md={{ span: 3 }}>
                <Tooltip title={`Filter by Type: ${(selectedTypes ?? []).map((type) => `#${type}`).join(' ')}`}>
                    <Select
                        placeholder="Type of coupon"
                        mode="multiple"
                        value={selectedTypes ?? []}
                        style={{ width: '100%', height: 32 }}
                        maxTagCount={1}
                        maxTagTextLength={10}
                        onChange={(e) => patchState({ selectedTypes: e })}
                    >
                        {(allowedCouponTypes ?? []).map((type) => (
                            <Select.Option key={type} value={type}>
                                {type}
                            </Select.Option>
                        ))}
                    </Select>
                </Tooltip>
            </Col>
            <Col>
                <Tooltip title={`Filter by Status`}>
                    <Radio.Group
                        value={status}
                        buttonStyle="solid"
                        style={{ width: '100%' }}
                        onChange={(e) => patchState({ status: e.target.value })}
                    >
                        {allCouponsStatus.map((v) => (
                            <Radio.Button key={`statusFilter-${v}`} value={v}>
                                {v ? AccountStatusEnums.Active : AccountStatusEnums.InActive}
                            </Radio.Button>
                        ))}
                    </Radio.Group>
                </Tooltip>
            </Col>
            <Col md={{ span: 4 }}>
                <Tooltip title={`Filter by starting Date`}>
                    <DatePicker.RangePicker
                        style={{ width: '100%' }}
                        value={rangePickerValue as any}
                        onChange={handleRangePickerChanged}
                    />
                </Tooltip>
            </Col>
        </>
    );
};
